var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 55,
    viewBox: "0 0 35 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5203 51.9585L30.2949 53.1696L34.6629 51.0673C34.6629 50.9933 34.6629 50.9193 34.6629 50.846L30.9012 49.9126C30.9012 49.9126 30.6921 51.0322 30.5203 51.9585Z",
    fill: "url(#paint0_linear_697_3137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.885 54.9947C34.5455 54.9947 34.6879 54.7903 34.6827 54.1737C34.6761 53.2827 34.6702 52.3913 34.665 51.4995L29.7123 54.9889C31.1034 54.9911 32.4943 54.993 33.885 54.9947Z",
    fill: "url(#paint1_linear_697_3137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.22 54.9883H29.7119L34.6646 51.4989C34.6646 51.3548 34.6646 51.2107 34.6646 51.0667L30.2966 53.169L29.22 54.9883Z",
    fill: "url(#paint2_linear_697_3137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6618 50.846C34.6618 50.5824 34.6618 50.3191 34.6618 50.056L30.9014 49.9126L34.6618 50.846Z",
    fill: "url(#paint3_linear_697_3137)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6618 50.846C34.6618 50.5824 34.6618 50.3191 34.6618 50.056L30.9014 49.9126L34.6618 50.846Z",
    fill: "url(#paint4_linear_697_3137)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6618 50.846C34.6618 50.5824 34.6618 50.3191 34.6618 50.056L30.9014 49.9126L34.6618 50.846Z",
    fill: "url(#paint5_linear_697_3137)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3805 42.6853C31.4867 42.6901 30.5939 42.6935 29.7019 42.6957L30.9014 49.9127L32.3805 42.6853Z",
    fill: "url(#paint6_linear_697_3137)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6592 50.056C34.6562 48.7453 34.6583 47.4344 34.6657 46.1233L30.9014 49.9125L34.6592 50.056Z",
    fill: "url(#paint7_linear_697_3137)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6657 46.1234C34.671 45.3324 34.679 44.5412 34.6899 43.7498C34.7023 42.9138 34.5213 42.673 33.6368 42.6788L32.3805 42.6853L30.9014 49.9127L34.6657 46.1234Z",
    fill: "url(#paint8_linear_697_3137)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3579 49.6322L30.2939 53.1696L29.4576 42.6963C28.3457 42.6989 27.2338 42.7006 26.1218 42.7015L18.3579 49.6322Z",
    fill: "url(#paint9_linear_697_3137)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5206 51.9584C30.6924 51.0322 30.9008 49.9125 30.9008 49.9125L29.6994 42.6956H29.459L30.2952 53.1689L30.5206 51.9584Z",
    fill: "url(#paint10_linear_697_3137)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5206 51.9585C30.6924 51.0322 30.9009 49.9126 30.9009 49.9126C30.9009 49.9126 30.6924 51.0322 30.5206 51.9585Z",
    fill: "url(#paint11_linear_697_3137)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5206 51.9585C30.6924 51.0322 30.9009 49.9126 30.9009 49.9126C30.9009 49.9126 30.6924 51.0322 30.5206 51.9585Z",
    fill: "url(#paint12_linear_697_3137)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.63 48.3885L18.5947 48.5515C18.4471 49.2284 18.3589 49.6302 18.3589 49.6322L26.1228 42.7014C24.0383 42.7014 21.954 42.7025 19.87 42.7047L18.6614 48.2451C18.6503 48.2957 18.6405 48.3418 18.63 48.3885Z",
    fill: "url(#paint13_linear_697_3137)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3581 49.6321L18.594 48.5514C18.6051 48.4988 18.6168 48.4443 18.6293 48.3885L18.6606 48.245C18.9435 46.9469 19.3923 44.89 19.8692 42.7046C18.5853 42.7046 17.3019 42.7081 16.0193 42.715L18.3581 49.6321Z",
    fill: "url(#paint14_linear_697_3137)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9257 54.486L20.048 52.006L18.3592 49.6323L12.9257 54.486Z",
    fill: "url(#paint15_linear_697_3137)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 54.9812H18.3494L20.048 52.0078L15.1299 54.9812Z",
    fill: "url(#paint16_linear_697_3137)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9257 54.4865L12.5148 54.9811H15.128L20.0461 52.0071L12.9257 54.4865Z",
    fill: "url(#paint17_linear_697_3137)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0481 52.0059L27.3926 54.9857H29.2218L30.2972 53.1683L20.0481 52.0059Z",
    fill: "url(#paint18_linear_697_3137)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2955 53.1697L18.3589 49.6323L20.0477 52.006L30.2955 53.1697Z",
    fill: "url(#paint19_linear_697_3137)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0481 52.0059L18.3495 54.9792C21.3639 54.9792 24.3782 54.9814 27.3926 54.9857L20.0481 52.0059Z",
    fill: "url(#paint20_linear_697_3137)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9258 54.4867L18.3581 49.6323L16.0205 42.7139C15.443 42.7139 14.8655 42.7169 14.288 42.723L12.9252 54.4867H12.9258Z",
    fill: "url(#paint21_linear_697_3137)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07593 41.9122L12.9248 54.4866L14.2876 42.7242H13.7741C12.879 42.73 12.7079 42.4743 12.7288 41.6474C12.7458 40.8871 12.7575 40.1264 12.7641 39.3652L2.07593 41.9115V41.9122Z",
    fill: "url(#paint22_linear_697_3137)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78322 50.6667L0.0192871 51.7215C0.0192871 52.5082 0.0192871 53.2946 0.0192871 54.0808C0.0192871 54.6734 0.0388864 55.0019 0.81763 54.9999C1.78191 54.9973 2.74663 54.9954 3.71179 54.9941C3.06893 53.5486 2.48161 52.2271 2.12947 51.4346L1.78322 50.6667Z",
    fill: "url(#paint23_linear_697_3137)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0192871 49.7917C0.0192871 50.4352 0.0192871 51.0782 0.0192871 51.7208L1.78322 50.666L0.0192871 49.7917Z",
    fill: "url(#paint24_linear_697_3137)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78406 50.6667L6.46762 54.9889C8.48373 54.9859 10.4994 54.9835 12.5146 54.9817L12.9249 54.4865L1.78406 50.6667Z",
    fill: "url(#paint25_linear_697_3137)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78357 50.6667C1.78357 50.6667 1.91423 50.9543 2.1246 51.4339L3.70691 54.9934L6.46779 54.9889L1.78422 50.6667H1.78357Z",
    fill: "url(#paint26_linear_697_3137)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0759 41.9121L0.0232068 43.7243C0.0232068 45.7468 0.0219003 47.7693 0.0192871 49.7918L1.78322 50.6661L2.0759 41.9121Z",
    fill: "url(#paint27_linear_697_3137)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78357 50.6662L1.78422 50.6669L12.9251 54.486L2.07625 41.9116L1.78357 50.6662Z",
    fill: "url(#paint28_linear_697_3137)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58936 33.7087L12.7825 37.8965C12.7825 37.7412 12.7825 37.586 12.7825 37.4311L8.7542 34.4201L4.58936 33.7087Z",
    fill: "url(#paint29_linear_697_3137)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82213 36.2265L2.26399 41.3405C2.15554 41.6962 2.09086 41.9091 2.09021 41.9116L12.7757 39.368C12.7796 38.8777 12.7818 38.3872 12.7823 37.8965L4.58911 33.7087L3.82213 36.2265Z",
    fill: "url(#paint30_linear_697_3137)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7812 37.4311C12.7777 36.3368 12.7642 35.2429 12.7407 34.1494C12.7407 34.1105 12.7407 34.0735 12.7407 34.0371L8.75549 34.4201L12.7812 37.4311Z",
    fill: "url(#paint31_linear_697_3137)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07589 41.9116L2.24967 41.3405C2.56784 40.2968 3.26034 38.0224 3.80782 36.2265L4.57284 33.7087L4.565 33.7133L4.54279 33.725L4.5062 33.7451L4.46569 33.7678L4.37946 33.8152L4.27297 33.8736L4.17824 33.9262L4.01622 34.0164L3.92802 34.0651L3.82741 34.1202L3.68891 34.1962L3.54061 34.276L3.46287 34.3189L3.30085 34.4084L3.08068 34.5292L2.96897 34.5941L2.80891 34.6823L2.68935 34.7472L2.34833 34.9348L2.2353 34.9997L1.80412 35.2373L1.55847 35.3723L1.26383 35.5346L1.03191 35.6644L0.848982 35.7591L0.65299 35.8656L0.0650127 36.1901L0.0212402 36.2141C0.0212402 37.8982 0.0212402 39.5826 0.0212402 41.2671L2.07328 41.9129L2.07589 41.9116Z",
    fill: "url(#paint32_linear_697_3137)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0246582 41.2664C0.0246582 42.0855 0.0246582 42.9048 0.0246582 43.7244L2.07735 41.9122L0.0246582 41.2664Z",
    fill: "url(#paint33_linear_697_3137)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0246582 28.4207V32.2703L4.57364 33.7086L0.0246582 28.4207Z",
    fill: "url(#paint34_linear_697_3137)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0.65706 35.8654L0.853052 35.759L1.03271 35.6597L1.26464 35.5299L1.55928 35.3676L1.80492 35.2326L2.23611 34.995L2.34913 34.9301L2.69016 34.7426L2.80971 34.6777L2.97173 34.5881L3.08345 34.5232L3.30361 34.4025L3.46563 34.3129L3.54338 34.27L3.69168 34.1883L3.83018 34.1123L3.93079 34.0571L4.01898 34.0085L4.18296 33.9182L4.27769 33.8657L4.38418 33.8073L4.47042 33.7599L4.51092 33.7372L4.54751 33.717L4.56972 33.7054L4.57756 33.7008L0.0246582 32.2703C0.0246582 33.5848 0.0246582 34.8992 0.0246582 36.2133L0.0684307 36.1893L0.65706 35.8654Z",
    fill: "url(#paint35_linear_697_3137)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74044 34.42L0.0246582 28.189V28.422L4.57364 33.7086L8.74044 34.42Z",
    fill: "url(#paint36_linear_697_3137)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1191 30.0038L13.2559 21.2472C13.1994 21.2346 13.1443 21.2165 13.0913 21.1934L8.74023 34.4194L21.1191 30.0038Z",
    fill: "url(#paint37_linear_697_3137)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6901 32.1476C21.5104 31.4706 21.2877 30.6314 21.1818 30.2335L21.1211 30.0044L8.74219 34.418L12.7274 34.0351C12.7313 33.325 12.9482 33.1264 13.7341 33.1303C16.4669 33.1485 19.199 33.1498 21.9318 33.1504H21.956L21.6901 32.1476Z",
    fill: "url(#paint38_linear_697_3137)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.607 21.27C16.3278 21.2739 15.0484 21.2806 13.7688 21.2902C13.5968 21.2955 13.4247 21.2812 13.256 21.2473L21.1192 30.0039L17.607 21.27Z",
    fill: "url(#paint39_linear_697_3137)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1191 30.0043C21.1191 30.0043 21.1427 30.0919 21.1799 30.2334L21.6901 32.1475C21.8378 32.7038 21.9567 33.1503 21.9567 33.1503H21.9717C23.6751 33.1503 25.3781 33.1518 27.0806 33.1549L21.1218 30.0017L21.1191 30.0043Z",
    fill: "url(#paint40_linear_697_3137)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4592 22.3292V22.3071V22.2721V22.226L27.4317 21.7288C27.4317 21.7035 27.4317 21.6775 27.4271 21.6509L27.4056 21.2615H25.511L27.4592 22.3331V22.3292Z",
    fill: "url(#paint41_linear_697_3137)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1193 30.0037L27.4564 22.3343L25.5017 21.2627C22.8695 21.2627 20.2367 21.2627 17.6039 21.2698L21.1161 30.0037H21.1193Z",
    fill: "url(#paint42_linear_697_3137)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1191 30.0037L27.078 33.1568C27.7544 33.1568 28.4294 33.1588 29.1032 33.1627L27.4588 22.333L21.1191 30.0037Z",
    fill: "url(#paint43_linear_697_3137)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9818 22.311L27.4591 22.3344L27.9478 22.4272L32.3282 23.2606C32.3321 22.9425 32.3365 22.6249 32.3413 22.3078C32.3413 22.239 32.3413 22.1779 32.3413 22.113L31.296 22.1604L27.9818 22.311Z",
    fill: "url(#paint44_linear_697_3137)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4263 21.7287C27.4387 21.9546 27.4478 22.124 27.4537 22.2259V22.272V22.307V22.333L27.9763 22.3096L31.2932 22.1603L32.3385 22.113C32.3163 21.4236 32.0824 21.2348 31.2801 21.2406C29.9857 21.2501 28.6913 21.2562 27.3969 21.2588C27.4047 21.4009 27.4119 21.532 27.4184 21.6482L27.4263 21.7287Z",
    fill: "url(#paint45_linear_697_3137)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9819 22.3109L31.2988 22.1616L27.9819 22.3109Z",
    fill: "url(#paint46_linear_697_3137)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9819 22.3109L31.2988 22.1616L27.9819 22.3109Z",
    fill: "url(#paint47_linear_697_3137)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M31.345 33.1725C32.1878 33.1784 32.3505 32.9304 32.34 32.1444C32.3317 31.5525 32.3248 30.9603 32.3191 30.3679L30.171 33.166L31.345 33.1725Z",
    fill: "url(#paint48_linear_697_3137)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4591 22.333L29.1068 33.1614L30.171 33.1666L32.3191 30.3685C32.2969 27.9985 32.3001 25.6288 32.3289 23.2592L27.9484 22.4271L27.4591 22.333Z",
    fill: "url(#paint49_linear_697_3137)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3288 23.2606L27.9484 22.4272L32.3288 23.2606Z",
    fill: "url(#paint50_linear_697_3137)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3288 23.2606L27.9484 22.4272L32.3288 23.2606Z",
    fill: "url(#paint51_linear_697_3137)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7398 34.4193L13.0908 21.1932C13.0642 21.1814 13.0384 21.1678 13.0137 21.1523L9.00308 23.1301L0.41469 27.3652L0.0227051 27.5599V28.1895L8.73849 34.4206L8.7398 34.4193Z",
    fill: "url(#paint52_linear_697_3137)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0238V24.4996L0.712106 19.9678L0 21.0238Z",
    fill: "url(#paint53_linear_697_3137)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97907 23.13L12.9897 21.1523C12.9569 21.1317 12.9264 21.1075 12.8989 21.0803L0.712759 19.9678L0 24.4996C0 25.4948 0 26.49 0 27.4853V27.5593L0.391985 27.3645L8.97907 23.13Z",
    fill: "url(#paint54_linear_697_3137)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02338 15.7471L8.01815 15.7504L7.4354 16.0879L1.6484 19.4403L0.733765 19.968L12.9232 21.0805C12.7553 20.9124 12.7174 20.6339 12.7272 20.2075C12.7272 20.0946 12.7318 19.9823 12.7344 19.8693L10.9051 14.0764L8.02338 15.7471Z",
    fill: "url(#paint55_linear_697_3137)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9099 14.0763L12.7568 14.7513C12.7507 14.367 12.7433 13.9832 12.7346 13.5999L10.9099 14.0756V14.0763Z",
    fill: "url(#paint56_linear_697_3137)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7346 19.8667C12.7712 18.1614 12.7779 16.4555 12.7549 14.7488L10.9099 14.0764L12.7346 19.8667Z",
    fill: "url(#paint57_linear_697_3137)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0.15532 9.68213L0.0246582 9.86062C0.0246582 12.9255 0.0246582 15.9906 0.0246582 19.056L0.736764 19.9679L0.15532 9.68213Z",
    fill: "url(#paint58_linear_697_3137)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0246582 19.0559V21.0239L0.736764 19.9678L0.0246582 19.0559Z",
    fill: "url(#paint59_linear_697_3137)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64849 19.4402L7.43549 16.0878L8.01824 15.7503L8.02347 15.747L10.9104 14.0763L0.156982 9.68213L0.73908 19.9679L1.64849 19.4402Z",
    fill: "url(#paint60_linear_697_3137)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M13.721 6.56396L0.155029 9.68143L10.9085 14.0756L13.721 6.56396Z",
    fill: "url(#paint61_linear_697_3137)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0222168 9.64453C0.0222168 9.71658 0.0222168 9.78862 0.0222168 9.86067L0.152878 9.68218L0.0222168 9.64453Z",
    fill: "url(#paint62_linear_697_3137)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960475 0.00512695H0.946102C0.133386 0.00512695 0.00795014 0.268648 0.00991006 0.988463C0.0173142 3.87508 0.021452 6.76148 0.0223231 9.64767L0.152985 9.68531L0.960475 0.00512695Z",
    fill: "url(#paint63_linear_697_3137)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7197 6.56401L4.80005 0.00843819C3.51957 0.00584192 2.2393 0.00302898 0.959251 0L0.155029 9.68213L13.7197 6.56401Z",
    fill: "url(#paint64_linear_697_3137)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2635 0.0202342C8.44247 0.0202342 6.6217 0.0169887 4.80115 0.010498L13.7195 6.56413L10.2635 0.0202342Z",
    fill: "url(#paint65_linear_697_3137)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7195 6.56409L19.4118 0.0234375C16.363 0.0234375 13.3143 0.0234375 10.2655 0.0234375L13.7195 6.56409Z",
    fill: "url(#paint66_linear_697_3137)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7196 6.564L20.305 11.6235L20.8407 0.0227051H19.4132L13.7196 6.564Z",
    fill: "url(#paint67_linear_697_3137)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2503 3.44532L22.0401 0.0234375H20.8406L20.3049 11.6236L24.2503 3.44532Z",
    fill: "url(#paint68_linear_697_3137)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7311 12.2953H19.4891L20.3051 11.6235L17.7311 12.2953Z",
    fill: "url(#paint69_linear_697_3137)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7195 6.56396L10.9103 14.0763L12.735 13.6005C12.735 13.4973 12.731 13.3947 12.7278 13.2915C12.7069 12.4802 12.9238 12.2764 13.7404 12.2809C15.0714 12.2883 16.4022 12.2933 17.7328 12.2959L20.3048 11.6234L13.7195 6.56396Z",
    fill: "url(#paint70_linear_697_3137)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2497 3.44385L20.3043 11.6227L26.827 10.9484L24.2497 3.44385Z",
    fill: "url(#paint71_linear_697_3137)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3045 11.6235L19.4885 12.2985C20.8487 12.2985 22.2089 12.2996 23.5691 12.3018L26.8271 10.9485L20.3045 11.6235Z",
    fill: "url(#paint72_linear_697_3137)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2505 3.44505L29.4913 0.0134277C27.0087 0.0181876 24.5249 0.021433 22.0397 0.0231638L24.2498 3.44505H24.2505Z",
    fill: "url(#paint73_linear_697_3137)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3302 0.0102539H29.4913L24.2505 3.44512L30.3302 0.0102539Z",
    fill: "url(#paint74_linear_697_3137)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3302 0.0102539H29.4913L24.2505 3.44512L30.3302 0.0102539Z",
    fill: "url(#paint75_linear_697_3137)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3302 0.0102539H29.4913L24.2505 3.44512L30.3302 0.0102539Z",
    fill: "url(#paint76_linear_697_3137)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2517 3.44312L24.25 3.44482L24.2517 3.44312Z",
    fill: "url(#paint77_linear_697_3137)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2517 3.44312L24.25 3.44482L24.2517 3.44312Z",
    fill: "url(#paint78_linear_697_3137)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2517 3.44312L24.25 3.44482L24.2517 3.44312Z",
    fill: "url(#paint79_linear_697_3137)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8277 10.9484L33.2275 7.45638L24.2504 3.44385L26.8277 10.9484Z",
    fill: "url(#paint80_linear_697_3137)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2498 3.4452L33.2269 7.45709L34.1591 0.259581C34.0226 0.0648612 33.7671 0.00384902 33.3327 0.00514716L30.3275 0.0103398L24.2504 3.4452H24.2498Z",
    fill: "url(#paint81_linear_697_3137)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2631 6.76253C34.2605 4.82874 34.2716 2.89538 34.2964 0.962461C34.3003 0.630788 34.2637 0.407509 34.1592 0.259521L33.2269 7.45703L34.2631 6.76253Z",
    fill: "url(#paint82_linear_697_3137)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2709 8.7675C34.2661 8.0994 34.2635 7.43129 34.2631 6.76318L33.2269 7.45769L34.2709 8.7675Z",
    fill: "url(#paint83_linear_697_3137)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8995 12.2421V12.2661V12.3031H27.5744L26.8276 10.9485C26.8276 10.9485 26.8557 11.4509 26.8995 12.2421Z",
    fill: "url(#paint84_linear_697_3137)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8995 12.2421L26.8276 10.9485L23.5696 12.3018H26.9015V12.2648L26.8995 12.2421Z",
    fill: "url(#paint85_linear_697_3137)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8276 10.9486L27.5776 12.3039C29.4348 12.3039 31.2919 12.3073 33.149 12.3142L33.2274 7.45728L26.8276 10.9486Z",
    fill: "url(#paint86_linear_697_3137)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1492 12.3142H33.3079C34.0266 12.3142 34.3127 12.2025 34.3003 11.3853C34.2872 10.5121 34.2776 9.63914 34.2715 8.76636L33.2263 7.45654L33.1492 12.3142Z",
    fill: "url(#paint87_linear_697_3137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_3137",
    x1: 30.8365,
    y1: 51.5502,
    x2: 36.5437,
    y2: 51.7711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B83CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_697_3137",
    x1: 32.4281,
    y1: 49.9288,
    x2: 31.582,
    y2: 67.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4184DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_697_3137",
    x1: 36.9114,
    y1: 50.7532,
    x2: 30.6148,
    y2: 53.8243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A70BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_697_3137",
    x1: 38.8639,
    y1: 51.4937,
    x2: 30.9995,
    y2: 49.5173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#419CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_697_3137",
    x1: 36.3545,
    y1: 36.8566,
    x2: 32.8429,
    y2: 50.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F7AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_697_3137",
    x1: 971.5,
    y1: 507.493,
    x2: 972.28,
    y2: 425.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B83CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_697_3137",
    x1: 32.206,
    y1: 49.6978,
    x2: 30.5637,
    y2: 39.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_697_3137",
    x1: 36.2546,
    y1: 36.8326,
    x2: 32.7443,
    y2: 50.2931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_697_3137",
    x1: 29.4563,
    y1: 48.4964,
    x2: 40.8053,
    y2: 36.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BBAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_697_3137",
    x1: 21.9099,
    y1: 53.5584,
    x2: 32.7248,
    y2: 43.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_697_3137",
    x1: 30.3423,
    y1: 50.0041,
    x2: 28.6999,
    y2: 40.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_697_3137",
    x1: 129.345,
    y1: 1053.67,
    x2: 164.768,
    y2: 881.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B83CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_697_3137",
    x1: 123.653,
    y1: 1063.39,
    x2: 63.5769,
    y2: 1065.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A1E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_697_3137",
    x1: 24.9397,
    y1: 33.793,
    x2: 21.389,
    y2: 50.2843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA2E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_697_3137",
    x1: 20.1168,
    y1: 32.7544,
    x2: 16.5661,
    y2: 49.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ACEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_697_3137",
    x1: 15.3958,
    y1: 51.7132,
    x2: 17.07,
    y2: 54.0965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449FE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3893DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_697_3137",
    x1: 1893.21,
    y1: 2445.36,
    x2: 1687.9,
    y2: 1887.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_697_3137",
    x1: 9.48342,
    y1: 57.4807,
    x2: 19.6032,
    y2: 51.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358DD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_697_3137",
    x1: 19.9259,
    y1: 53.0645,
    x2: 30.172,
    y2: 54.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449FE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348FD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_697_3137",
    x1: 30.0368,
    y1: 54.0298,
    x2: 18.113,
    y2: 50.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3694DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_697_3137",
    x1: 3089.02,
    y1: 2245.46,
    x2: 3026.45,
    y2: 1603.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4184DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_697_3137",
    x1: 15.1804,
    y1: 50.6929,
    x2: 11.5942,
    y2: 39.9458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_697_3137",
    x1: 3.80393,
    y1: 49.0785,
    x2: 16.4495,
    y2: 46.0289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_697_3137",
    x1: 1406.12,
    y1: 4703.29,
    x2: 970.965,
    y2: 4086.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4184DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_697_3137",
    x1: 472.012,
    y1: 1866.24,
    x2: 376.466,
    y2: 2041.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_697_3137",
    x1: 3836.69,
    y1: 3451.19,
    x2: 3518.05,
    y2: 4335.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4184DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_697_3137",
    x1: 1788.77,
    y1: 3604.6,
    x2: 1294.53,
    y2: 4180.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_697_3137",
    x1: -2.25684,
    y1: 49.9852,
    x2: 4.16136,
    y2: 44.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45A2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#409DE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_697_3137",
    x1: 10.664,
    y1: 56.4118,
    x2: -0.104125,
    y2: 43.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2382C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_697_3137",
    x1: 4.35482,
    y1: 35.0633,
    x2: 8.51809,
    y2: 35.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBAF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_697_3137",
    x1: 9.1283,
    y1: 35.0731,
    x2: 6.65905,
    y2: 43.2856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CD3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_697_3137",
    x1: 9.5669,
    y1: 33.3459,
    x2: 15.5301,
    y2: 37.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_697_3137",
    x1: -7571.9,
    y1: -10.537,
    x2: -7672.53,
    y2: 596.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47AAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2386C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_697_3137",
    x1: 0.269649,
    y1: 38.3741,
    x2: 1.68822,
    y2: 46.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3495DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_697_3137",
    x1: 0.564291,
    y1: 33.6411,
    x2: 2.92553,
    y2: 30.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BB7F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_697_3137",
    x1: 4.002,
    y1: 35.4987,
    x2: -3.44327,
    y2: 33.1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA1E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_697_3137",
    x1: 8.19951,
    y1: 35.1664,
    x2: -0.996476,
    y2: 28.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F8DC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_697_3137",
    x1: -9106.19,
    y1: -2094.69,
    x2: -9879.28,
    y2: 465.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8EC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_697_3137",
    x1: -2770.7,
    y1: -449.868,
    x2: -3676.67,
    y2: -420.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_697_3137",
    x1: 13.4984,
    y1: 16.4507,
    x2: 19.1825,
    y2: 30.7726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_697_3137",
    x1: 23.5135,
    y1: 29.376,
    x2: 24.339,
    y2: 32.5247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A98D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_697_3137",
    x1: 27.6806,
    y1: 21.9346,
    x2: 15.6287,
    y2: 15.2418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_697_3137",
    x1: -5060.25,
    y1: -1057.32,
    x2: -6764.67,
    y2: -1902.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49BEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_697_3137",
    x1: -6494.98,
    y1: -1294.98,
    x2: -6332.11,
    y2: 185.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_697_3137",
    x1: 27.4852,
    y1: 22.9055,
    x2: 33.0173,
    y2: 22.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_697_3137",
    x1: 27.4354,
    y1: 21.7962,
    x2: 32.9668,
    y2: 21.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_697_3137",
    x1: -571.837,
    y1: 103.179,
    x2: -571.863,
    y2: 90.5111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_697_3137",
    x1: -571.837,
    y1: 103.179,
    x2: -571.863,
    y2: 90.5126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_697_3137",
    x1: 29.8627,
    y1: 34.7621,
    x2: 37.5984,
    y2: 24.5543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46B0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA9E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_697_3137",
    x1: 36.1069,
    y1: 29.2358,
    x2: 26.4869,
    y2: 27.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_697_3137",
    x1: -721.763,
    y1: 474.339,
    x2: -722.373,
    y2: 403.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_697_3137",
    x1: -640.681,
    y1: 351.921,
    x2: -645.308,
    y2: 479.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_697_3137",
    x1: -11157.6,
    y1: -2865.85,
    x2: -12008.8,
    y2: -187.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_697_3137",
    x1: 0.773517,
    y1: 22.3304,
    x2: -2.73235,
    y2: 21.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46B7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2798D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_697_3137",
    x1: -1.97234,
    y1: 24.9111,
    x2: 11.612,
    y2: 18.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48BBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BBEF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_697_3137",
    x1: 2.52644,
    y1: 23.0167,
    x2: 12.6641,
    y2: 17.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_697_3137",
    x1: 15.5562,
    y1: 15.2037,
    x2: 11.1011,
    y2: 13.5531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BCBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B0E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_697_3137",
    x1: 10.5428,
    y1: 20.0368,
    x2: 12.7659,
    y2: 14.6361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_697_3137",
    x1: -0.174601,
    y1: 9.7003,
    x2: 0.400633,
    y2: 19.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36AFE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_697_3137",
    x1: 0.257236,
    y1: 20.3372,
    x2: -3.91071,
    y2: 14.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48BBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BBF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_697_3137",
    x1: 9.12952,
    y1: 18.3731,
    x2: -1.60358,
    y2: 13.9298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_697_3137",
    x1: 8.27434,
    y1: 4.55121,
    x2: 5.49452,
    y2: 12.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F9DCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_697_3137",
    x1: 0.126093,
    y1: 9.78148,
    x2: -8.31942,
    y2: 7.36332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36AEE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_697_3137",
    x1: 0.741616,
    y1: -2.68591,
    x2: -0.270891,
    y2: 9.6468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_697_3137",
    x1: 7.78893,
    y1: -2.10752,
    x2: 6.77578,
    y2: 10.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A4D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_697_3137",
    x1: 14.6837,
    y1: 5.26989,
    x2: 2.20201,
    y2: -4.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ACAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F9FCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_697_3137",
    x1: 20.1808,
    y1: 3.77505,
    x2: 7.73682,
    y2: 2.09532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DB4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_697_3137",
    x1: 17.5192,
    y1: -1.86478,
    x2: 16.9111,
    y2: 11.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49D0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_697_3137",
    x1: 18.2477,
    y1: 10.6435,
    x2: 22.1514,
    y2: 2.44411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_697_3137",
    x1: -888.045,
    y1: 483.452,
    x2: -893.004,
    y2: 535.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BCBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B0E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_697_3137",
    x1: 17.949,
    y1: 14.6494,
    x2: 11.3971,
    y2: 9.54861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ACFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_697_3137",
    x1: 21.2248,
    y1: 4.46872,
    x2: 23.7722,
    y2: 11.9834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_697_3137",
    x1: 26.8794,
    y1: 11.4509,
    x2: 20.3583,
    y2: 12.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ACAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AAADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_697_3137",
    x1: 29.5475,
    y1: -1.8838,
    x2: 23.2606,
    y2: 1.71347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DCBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_697_3137",
    x1: -3194.94,
    y1: 1706.52,
    x2: -3067.23,
    y2: 2104.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DCBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_697_3137",
    x1: 24.3772,
    y1: 3.63464,
    x2: 34.7133,
    y2: -3.22361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_697_3137",
    x1: 34.2579,
    y1: -3.81015,
    x2: 30.2091,
    y2: -0.550777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_697_3137",
    x1: 115.976,
    y1: 146.198,
    x2: 115.879,
    y2: 146.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_697_3137",
    x1: 115.927,
    y1: 146.236,
    x2: 116.034,
    y2: 146.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_697_3137",
    x1: 116.089,
    y1: 146.145,
    x2: 115.976,
    y2: 146.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DCBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_697_3137",
    x1: 32.0313,
    y1: 10.0981,
    x2: 23.0739,
    y2: 6.04124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_697_3137",
    x1: -4125.3,
    y1: 4149.18,
    x2: -4801.03,
    y2: 2786.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_697_3137",
    x1: 35.6579,
    y1: 6.31597,
    x2: 30.5606,
    y2: -0.143473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48BDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_697_3137",
    x1: 33.696,
    y1: 8.14699,
    x2: 40.2076,
    y2: 3.72645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38ABE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_697_3137",
    x1: -231.28,
    y1: 756.196,
    x2: -240.672,
    y2: 642.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_697_3137",
    x1: -951.636,
    y1: 661.861,
    x2: -1021.33,
    y2: 972.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_697_3137",
    x1: 36.1902,
    y1: 20.3374,
    x2: 30.0877,
    y2: 9.16711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_697_3137",
    x1: 33.7959,
    y1: 7.46563,
    x2: 33.5631,
    y2: 22.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48BBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35A8E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.f9e8203820d610b5068a6aabfb00926e.svg";
export { ForwardRef as ReactComponent };